import { POLICY_DETAILS } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import PolicyDetails from './index';
import PolicyDetailsThunk from './thunk';

const module: ModulesList = {
  [POLICY_DETAILS]: {
    path: '/policy-details',
    component: PolicyDetails,
    thunk: PolicyDetailsThunk,
  },
};

export default module;
